<template>
  <div class="banner">

    <div class="search">
      <span class="icon"></span>
      <input type="text" class="input" placeholder="搜索职位" @keydown.enter="search" ref="input" v-model="value"/>
      <button class="btn" @click="search">搜索</button>
    </div>
  </div>
</template>

<script>


export default {
  name: "banner",
  components: {},
  data() {
    return {
      value: ""
    }
  },
  created() {
    this.value = window.sessionStorage.getItem('value')
  },
  watch: {

    $route: {
      // 监听变化处理函数，默认名为handler不可以改变
      handler(nv, ov) {
        this.value = window.sessionStorage.getItem('value')
      },
      // 开启深度监听
      // deep: true,
      // 默认执行一次
      immediate: true
    }
  },
  methods: {
    //搜索事件
    search() {
      window.sessionStorage.setItem('value', this.value)
      if (this.$route.name === 'sqzw') {
        this.$router.push('/shzp')
      }
      // this.$emit('search')
      eventBus.$emit('search')
      // this.value = ''
    }
  },
}
</script>

<style scoped>
.banner {
  width: 100%;
  height: 410px;
  background-image: url("/src/assets/img/沃特招聘banner.png");
  background-size: 101% 100%;
  position: relative;
  font-family: normal;
  z-index: 9;
}

.search {
  width: 1200px;
  height: 70px;
  /*background: #3772d3;*/
  border-radius: 4px;
  box-shadow: 0px 3px 15px 0px rgba(55, 114, 211, 0.10);
  position: absolute;
  left: 50%;
  bottom: -50px;
  transform: translateX(-50%);
  box-sizing: border-box;
  padding-left: 1px;
  overflow: hidden;
}

.input {
  box-sizing: border-box;
  width: calc(1200px - 166px);
  height: 70px;
  border: none;
  outline-style: none;
  padding: 26px 0px;
  padding-left: 55px;
  /*background-color: pink;*/
  font-size: 18px;

  /*background-image: none;*/
  background-size: 21px 21px;
  background-repeat: no-repeat;
  background-position: 25px 25px;
  float: left;
  position: relative;
}

.icon {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 25px;
  left: 21px;

  background-image: url("/src/assets/img/搜索.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 9;
  user-select: none;
}

.bg {

}

input::-webkit-input-placeholder {
  position: relative;
  /*left: 55px;*/
}

input:after {
}

.btn {
  width: 165px;
  height: 70px;
  background: #3772d3;
  font-size: 18px;
  color: #ffffff;
  box-sizing: border-box;
  border: none;
  user-select: none;
  cursor: pointer;
}
</style>